export default __webpack_public_path__ + "static/media/six-thinking-hats.a0acf903.svg";